import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { NavBar } from "./components/NavBar";
import { Banner } from "./components/Banner";
import { About } from "./components/About";
import { Skills } from "./components/Skills";
import { Projects } from "./components/Projects";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { NotFound } from "./components/NotFound";
import { CustomCursor } from './components/CustomCursor';
import TrackVisibility from 'react-on-screen';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { useHashRedirect } from './hooks/useHashRedirect';
import { _2801 as MusicPlayer2801 } from "./components/Player/MusicPlayer";

function MainContent() {
  return (
    <>
      <TrackVisibility partialVisibility offset={100}>
        {({ isVisible }) => (
          <div className={`reveal ${isVisible ? 'active' : ''}`}>
            <Banner />
          </div>
        )}
      </TrackVisibility>

      <TrackVisibility partialVisibility offset={100}>
        {({ isVisible }) => (
          <div className={`reveal delay-200 ${isVisible ? 'active' : ''}`}>
            <Skills />
          </div>
        )}
      </TrackVisibility>

      <TrackVisibility partialVisibility offset={100}>
        {({ isVisible }) => (
          <div className={`reveal delay-400 ${isVisible ? 'active' : ''}`}>
            <Projects />
          </div>
        )}
      </TrackVisibility>

      <TrackVisibility partialVisibility offset={100}>
        {({ isVisible }) => (
          <div className={`reveal delay-200 ${isVisible ? 'active' : ''}`}>
            <About />
          </div>
        )}
      </TrackVisibility>

      <TrackVisibility partialVisibility offset={100}>
        {({ isVisible }) => (
          <div className={`reveal delay-400 ${isVisible ? 'active' : ''}`}>
            <Contact />
          </div>
        )}
      </TrackVisibility>

      <TrackVisibility partialVisibility offset={100}>
        {({ isVisible }) => (
          <div className={`reveal delay-600 ${isVisible ? 'active' : ''}`}>
            <Footer />
          </div>
        )}
      </TrackVisibility>
    </>
  );
}

function AppContent() {
  useHashRedirect();

  return (
    <div className="App">
      <CustomCursor />
      <NavBar />
      <Routes>
        <Route path="/" element={<MainContent />} />
        <Route path="/404" element={<NotFound />} />
        <Route path="/2801" element={<MusicPlayer2801 />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <ToastContainer />
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
